/**
 * Canonical admin-portal routes per dashboard catalog source id. Used to prefill
 * widget click-through routes (KPI click route → `list`, table row click → `detail`).
 *
 * These are app-specific router paths (the member-portal would map the same source
 * ids to its own routes), which is why they live here and not in the backend
 * catalog or the @ams/dashboard library. `:id` is the row-id placeholder the table
 * substitutes at click time. Sources with no meaningful destination are omitted —
 * prefill simply no-ops for them.
 */
export interface DashboardSourceRoutes {
  list?: string;
  detail?: string;
}

export const DASHBOARD_SOURCE_ROUTES: Record<string, DashboardSourceRoutes> = {
  accounts: { list: '/memberships/accounts', detail: '/memberships/accounts/:id' },
  chapters: { list: '/chapters', detail: '/chapters/:id' },
  events: { list: '/events', detail: '/events/:id' },
  pipeline_items: { list: '/engagement/pipelines' },
  activities: { list: '/activities' },
  resources: { list: '/resources' },
  cms_content: { list: '/cms/content', detail: '/cms/content/:id' },
  staff: { list: '/users', detail: '/users/:id' },
  // memberships (billing periods), event_registrations, tasks: no standalone
  // detail/list page — intentionally omitted so prefill leaves the field blank.
};
